module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "gpw-yearly--cover.fa3c2a8e.jpg";